export const FEED_INVESTMENTS_METADATA = [
  'investment_item',
  'data_set',
  'file_format',
  'delivery_type',
  'delivery_destination',
]

export const FEED_PERFORMANCE_REPORTS_METADATA = [
  'performance_report',
  'delivery_type',
  'delivery_destination',
]

export const PARAMETER_FEED_NAMES = [
  'investment_item',
  'data_set',
  'performance_report',
  'delivery_destination',
]

export const PARAMETER_SCHEDULE_NAMES = {
  startDay: 'Start',
  frequency: 'Repeat',
  runningTime: 'Time',
  feedName: 'Feed Name',
  feedId: 'Feed ID',
  id: 'Schedule ID',
  sourceType: 'Source Type',
}

export const PERFORMANCE_REPORT = 'performance report'

export const DELIVERY_DESTINATION = 'delivery_destination'

export const DELIVERY_TYPE = 'delivery_type'
export const DELIVERY_TYPE_EMAIL = 'email'

export const TAB_COMPONENTS = {
  general: 'GeneralTab',
  schedules: 'SchedulesTab',
  exportActivityLog: 'ActivityLogTab',
  activityLog: 'ActivityLogTab',
}

export const TAB_NAMES = {
  general: 'general',
  schedules: 'schedules',
  exportActivityLog: 'exportActivityLog',
  activityLog: 'activityLog',
}

export const EMPTY_STATE_SCHEDULES = {
  title: 'flyover.feeds.schedules.empty.title',
  message: 'flyover.feeds.schedules.empty.message',
  button: 'flyover.feeds.schedules.empty.button',
}

export const EMPTY_STATE_ACTIVITY_LOGS = {
  title: 'flyover.schedules.activityLog.empty.title',
  message: 'flyover.schedules.activityLog.empty.message',
  button: '',
}

export const EMPTY_STATE_EXPORT_LOGS = {
  title: 'flyover.feeds.exportActivityLog.empty.title',
  message: 'flyover.feeds.exportActivityLog.empty.message',
  button: '',
}

export const VIEWS = { feeds: 'feeds', schedules: 'schedules' }

export const IN_PROGRESS_STATUS = 'IN PROGRESS'

export const TIMES = { startTime: 'startTime', endTime: 'endTime' }

export const TRIGGER_TYPES = { api: 'API' }
